export const resolveProducts = entityStubs => (dispatch, getState) => {
  const { entities } = getState();
  return entityStubs.map(stub => entities[stub.etype][stub.eid]).filter(entity => !!entity);
};
